export default function (state, action) {
  if (typeof state === 'undefined') {
    return {
      postName: null,
      post: null
    };
  }

  switch(action.type) {
    case 'SET POST NAME':
      return Object.assign({}, state, {
        postName: action.postName
      });
    case 'LOAD POST':
      return Object.assign({}, state, {
        post: action.post
      });
    case 'UNLOAD POST':
      return Object.assign({}, state, {
        post: null
      });
    case 'CLEAR POST':
      return Object.assign({}, state, {
        postName: null,
        post: null
      });
  }
  
  return state;
}
